/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type RenderTableGroupInput = {
    id?: (string | null);
    group_type?: RenderTableGroupInput.group_type;
    /**
     * LX group expression. Required for expression groups.
     */
    expression?: (string | null);
    /**
     * Namespace id/name. Defaults to request namespace.
     */
    namespace?: (string | null);
    /**
     * For time_series views, Lumonic defaults this to true so rows include a date axis.
     */
    include_date?: (boolean | null);
    limit?: (number | null);
    tag_category_id?: (string | null);
    tag_category_name?: (string | null);
    /**
     * Deprecated compatibility flag. Cashflow routing is detected from property metadata.
     */
    is_cashflow?: boolean;
};

export namespace RenderTableGroupInput {

    export enum group_type {
        EXPRESSION = 'expression',
        DATE = 'date',
        CASHFLOW_TAG = 'cashflow_tag',
    }


}

